import { Tabs as MuiTabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledMuiTabs = styled(MuiTabs, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<{
    $isIconGivenForEveryItem: boolean | undefined;
    $isSquareOnMobile?: boolean;
}>`
    ${({
        theme,
        $isIconGivenForEveryItem,
        $isSquareOnMobile,
    }: {
        theme: Theme;
        $isIconGivenForEveryItem: boolean | undefined;
        $isSquareOnMobile?: boolean;
    }) => `
        margin: ${theme.tggSpacing([0, rem(0.8)], [0, 2])};
        background-color: ${theme.palette.grey[100]};
        border-radius: ${
            $isSquareOnMobile
                ? $isIconGivenForEveryItem
                    ? `${theme.tggSpacing(rem(1.6), 3)}`
                    : `${theme.tggSpacing(rem(1.6), 4)}`
                : `${theme.tggSpacing(rem(36), 90)}`
        };

        ${theme.breakpoints.up('desktop')} {
            border-radius: ${theme.tggSpacing(rem(36), 90)};
        }

        & .MuiTabs-flexContainer {
            height: 100%;
        }

        & .MuiTabs-indicator {
            height: 100%;
            background-color: ${theme.getRebrandingColor(theme.palette.common.blue, theme.palette.tgg.surface.action.selection.activated)};
            border-radius: ${
                $isSquareOnMobile
                    ? $isIconGivenForEveryItem
                        ? `${theme.tggSpacing(rem(1.6), 3)}`
                        : `${theme.tggSpacing(rem(1.6), 4)}`
                    : `${theme.tggSpacing(rem(36), 90)}`
            };

            ${theme.breakpoints.up('desktop')} {
                border-radius: ${theme.tggSpacing(rem(36), 90)};
            }
        }

        button {
            flex-basis: auto;
            min-width: ${theme.tggSpacing(0, 0)};
            min-height: ${theme.tggSpacing(0, 0)};
            color: ${theme.palette.common.blue};
            transition: color 0.3s ease;
            flex: 1;
            padding: ${theme.tggSpacing(rem(0.8), [3, 2])};
            ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(rem(0.8), [3, 4])};
            }
        }
svg{
    width:${theme.tggSpacing('unset', 6)};
    height: ${theme.tggSpacing('unset', 6)};
    margin-bottom: ${theme.tggSpacing(rem(0.6), 1)} !important;
    }
    svg g {
        fill:${theme.getRebrandingColor(theme.palette.primary.main, theme.palette.tgg.icon.action.main)};
    }

    & button.Mui-selected {
        color: ${theme.palette.common.white};
        svg g {
            fill: ${theme.getRebrandingColor(theme.palette.primary.main, theme.palette.tgg.icon.action.inverse.main)};
        }
    }

        .MuiTab-iconWrapper {
            z-index: 1;
        }
    `}
`;

export const StyledTab = styled(Tab, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<{
    $isIconGivenForEveryItem: boolean | undefined;
    $numberOfTabs: number;
    $customStyles: boolean | undefined;
}>`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_16_bold_desktop_15};
    ${({ theme }: { theme: Theme }) => `
        text-transform:${theme.isRebranding('lowercase', 'unset')};
        opacity: 1;
        span {
            width: ${({ $customStyles }: { $customStyles?: boolean }) => $customStyles && `${theme.tggSpacing(rem(2.5), 6.25)}`};
        }

        &:focus-visible {
            border: ${theme.tggSpacing(rem(0.1), 0.25)} solid
                ${theme.palette.primary.main};
        }

        ${theme.breakpoints.up('desktop')} {
            span {
                min-width: ${({ $customStyles }: { $customStyles?: boolean }) => $customStyles && `${theme.tggSpacing(rem(8.1), 20.25)}`}
                ;
            }
        }
    `}
`;

export const StyledLabel = styled('span')`
    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding(
            theme.typography.text_14_bold_desktop_16,
            theme.typography.tabLabelSmallRebrand,
        )};
    position: relative;
    z-index: 1;
`;

export const StyledContent = styled('div')<{ $height: string }>`
    height: ${({ $height }) => $height};
    overflow: hidden;
    transition: height 0.3s ease;
`;
